/* sdx-product-hotspot — tap-to-open bubble (mobile) + click-outside close. */
(function () {
  'use strict';

  function init() {
    var pins = document.querySelectorAll('[data-sdx-pin]');
    pins.forEach(function (pin) {
      var trigger = pin.querySelector('[data-sdx-pin-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = pin.classList.contains('is-open');
        document.querySelectorAll('[data-sdx-pin].is-open').forEach(function (p) {
          p.classList.remove('is-open');
        });
        if (!isOpen) pin.classList.add('is-open');
      });
    });

    document.addEventListener('click', function () {
      document.querySelectorAll('[data-sdx-pin].is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-sdx-pin].is-open').forEach(function (p) {
          p.classList.remove('is-open');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
